import {
  localStorageStore,
  useStoredFilters,
} from 'works/legacy/lib/hooks/use-stored-filters';
import { useQuery } from '@common/hooks';
import {
  PaginatedCandidateSubmissionsQuery,
  StaffingRequestStatesType,
} from '@applicant-flow/graphql/queries';

type Props = {
  localStorageKey: string;
  statesFilter: StaffingRequestStatesType[];
};

export function useSubmissionsQueryHandler({
  localStorageKey,
  statesFilter,
}: Props) {
  const [submissionFilters] = useStoredFilters<Record<string, string[]>>(
    localStorageKey,
    {
      store: localStorageStore,
    }
  );

  const {
    error,
    data: rawData,
    fetchMore,
    loading,
  } = useQuery(PaginatedCandidateSubmissionsQuery, {
    variables: {
      offset: 0,
      limit: 10,
      filters: submissionFilters,
      states: statesFilter,
    },
  });

  const total = rawData?.paginatedStaffingRequestApplications?.totalCount;

  const data =
    rawData?.paginatedStaffingRequestApplications
      ?.staffingRequestApplications || [];

  return {
    loading,
    error,
    data,
    total,
    fetchMore,
  };
}
